import { render } from "./CheckboxGroupDetail.vue?vue&type=template&id=5afc332c"
import script from "./CheckboxGroupDetail.vue?vue&type=script&lang=js"
export * from "./CheckboxGroupDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__